import { Button } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { commonPathnames } from "../../../../../helper";

type Props = {
  primary: boolean;
};

const OpenTicketProblemButton: React.FC<Props> = ({ primary }) => (
  <Button
    data-id="ticket-problem-button"
    appearance={primary ? "primary" : undefined}
    href={commonPathnames.serviceDeskReportProblem}
    Elem="a"
  >
    <FormattedMessage id="serviceDesk.button.text" />
  </Button>
);

export default OpenTicketProblemButton;
